import { DataGroupSensitivityCategory } from '@ariksa/abac/api';
import { Box, HStack, Stack } from '@chakra-ui/react';
import { map } from 'lodash';

import { renderDataTypeTag } from 'components/DataDisplay/DataType/render';
import { ButtonGroupItem } from 'components/DataEntry';
import { formatTooltip, getIconColor, PlusCountTag } from 'components/index';

export const dataAccessManagementViewByItems: ButtonGroupItem[] = [
  {
    label: 'Policies',
    value: 'policies',
  },
  {
    label: 'Data Groups',
    value: 'data_groups',
  },
];

export const dataGroupDrawerViewByItems: ButtonGroupItem[] = [
  {
    label: 'JIT',
    value: 'jit_enabled',
  },
  {
    label: 'Data Access',
    value: 'data_access',
  },
];

export const renderDataGroupSensitivityLabels = categories => {
  const visibleCategories = (categories ?? []).filter(
    category => category !== DataGroupSensitivityCategory.Unknown,
  );

  return visibleCategories.length ? (
    <HStack>
      {visibleCategories[0] &&
        renderDataTypeTag(visibleCategories[0], {
          showIcon: false,
          color: getIconColor(visibleCategories[0]),
        })}
      {visibleCategories.length > 1 && (
        <PlusCountTag
          count={visibleCategories.length - 1}
          tooltip={formatTooltip({
            header: 'Sensitivity Labels',
            content: (
              <Stack>
                {map(visibleCategories.slice(1), o => (
                  <Box>{o}</Box>
                ))}
              </Stack>
            ),
          })}
        />
      )}
    </HStack>
  ) : (
    '-'
  );
};
